import MobileDetect from "mobile-detect";

export const deviceType = () => {
  const mobileDetect = new MobileDetect(window.navigator.userAgent);

  if (mobileDetect.phone()) {
    return "Mobile";
  }
  if (mobileDetect.tablet()) {
    return "Tablet";
  }

  return "Desktop";
};

export const deviceModel = () => {
  const mobileDetect = new MobileDetect(window.navigator.userAgent);

  return mobileDetect.phone() || mobileDetect.tablet() || mobileDetect.os();
};

export const isChrome = () => navigator.userAgent.indexOf("Chrome") > -1;

export const pageUrl = () => window.location.href;
export const pagePath = () => window.location.pathname;
export const pageReferer = () => document.referrer;
export const viewportWidth = () => window.innerWidth;
export const viewportHeight = () => window.innerHeight;
